import React from "react";
import { IGameState, defaultGameState } from "./GameStateInterface";

export const GameStateContext = React.createContext<IGameState>(
  defaultGameState
);
export const GameStateProvider = GameStateContext.Provider;
export const GameStateConsume = GameStateContext.Consumer;
